import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

const seoArticles = allArticles.filter(a => a.slug !== 'best-sugargoo-spreadsheet-2026').slice(0, 9);

export default function ArticleCards() {
  return (
    <section className="w-full px-6 md:px-10 py-20 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200/60 text-xs font-medium text-foreground-500 tracking-wide uppercase">
            Shopping Guides &amp; Tips
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Expert Sugargoo Spreadsheet Articles
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            In-depth guides to help you master spreadsheet shopping — from QC inspection to shipping hacks
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col rounded-lg bg-background-50 border border-background-200/60 hover:border-accent-300/50 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="h-48 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-xs text-foreground-400 mb-2">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{article.author}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug group-hover:text-accent-700 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="mt-auto pt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-accent-600 group-hover:text-accent-700 transition-colors">
                  <span>Read Article</span>
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/best-sugargoo-spreadsheet-2026"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300/40 text-sm font-medium text-foreground-700 hover:border-foreground-500 hover:text-foreground-950 transition-all whitespace-nowrap"
          >
            <span>View All Guides</span>
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}